import { GraphScoringComponent } from './graph-scoring.component';

export default angular
  .module('sfMobile.components.graphScoring', [
    'sfMobile.components.contextualGraph',
    'sfMobile.services.reportScoring',
  ])
  .component('sfGraphScoring', GraphScoringComponent).name;
